const SummaryCard = ({ title, value, count, icon, color, isCurrency = true }) => (
    <div className={`p-5 rounded-xl border border-gray-100 shadow-sm bg-white`}>
        <div className="flex items-start justify-between">
            <div>
                <p className="text-sm font-medium text-gray-500">{title}</p>
                <h3 className="text-2xl font-bold mt-1 text-gray-900">
                    {isCurrency ? `₦${value.toLocaleString()}` : value}
                </h3>
                {count !== undefined && (
                    <p className="text-xs text-gray-400 mt-1">{count} transactions</p>
                )}
            </div>
            <div className={`p-3 rounded-lg ${color}`}>
                {icon}
            </div>
        </div>
    </div>
);

export default SummaryCard